export interface StaffOnlyNoticeProps {
  tabLabel: string;
}

/**
 * MER-688: placeholder for a `staff_only` manifest tab (or the Insights /
 * Findings routes) reached by a client session. Same frame as
 * UpgradeUnlock, the tier-lock placeholder, so a client who types the URL
 * gets an honest card, never a blank page and never a bare 404. The nav
 * does not link here for clients; this only covers the direct-URL path.
 * UI gate on top of RLS: the manifest is public, the data is not.
 */
export default function StaffOnlyNotice(props: StaffOnlyNoticeProps) {
  return (
    <section
      role="region"
      aria-label={`${props.tabLabel} is available to Meridian staff only`}
      style={{
        display: "grid",
        placeItems: "center",
        padding: 48,
        background: "var(--bg-card)",
        border: "1px dashed var(--border-subtle)",
        borderRadius: 14,
        textAlign: "center",
      }}
    >
      <div>
        <div style={{ fontSize: 12, color: "var(--text-muted)", marginBottom: 8 }}>
          MERIDIAN STAFF
        </div>
        <h2 style={{ fontSize: 22, marginBottom: 8 }}>{props.tabLabel}</h2>
        <p style={{ color: "var(--text-muted)", maxWidth: 420 }}>
          This view is available to Meridian staff.
        </p>
      </div>
    </section>
  );
}
